"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressStatusUpdate = exports.ProgressStatus = void 0;
/**
 * Possible values for a progress status that can be used to represent the status of different objects and entities.
 *
 * Note : This enum is voluntarily different from the InspectionStatus which can only be certain values.
 *
 * *Swagger Schema Reference :* `ProgressStatus`
 */
var ProgressStatus;
(function (ProgressStatus) {
    /**
     * Indicates that a process has not been started by the server.
     */
    ProgressStatus["NOT_STARTED"] = "NOT_STARTED";
    /**
     * Indicates that a process should soon be started by the server.
     */
    ProgressStatus["TODO"] = "TODO";
    /**
     * Indicates that the server has started the process,
     */
    ProgressStatus["IN_PROGRESS"] = "IN_PROGRESS";
    /**
     * Indicates that the server has successfully completed the process.
     */
    ProgressStatus["DONE"] = "DONE";
    /**
     * Indicates that an error occurred during the process.
     */
    ProgressStatus["ERROR"] = "ERROR";
    /**
     * Indicates that the process has been aborted and did not complete.
     */
    ProgressStatus["ABORTED"] = "ABORTED";
    /**
     * Indicates that the server has successfully completed the process and that a resource is reviewing it.
     */
    ProgressStatus["IN_REVIEW"] = "IN_REVIEW";
    /**
     * Indicates that the server has successfully completed the process and that a resource has validated it.
     */
    ProgressStatus["VALIDATED"] = "VALIDATED";
})(ProgressStatus = exports.ProgressStatus || (exports.ProgressStatus = {}));
/**
 * Possible values that cna be passed to the API when updating the progress status of an object.
 *
 * *Swagger Schema Reference :* `ProgressStatusPostPatch`
 */
var ProgressStatusUpdate;
(function (ProgressStatusUpdate) {
    /**
     * Indicates that a process has not been started by the server.
     */
    ProgressStatusUpdate["NOT_STARTED"] = "NOT_STARTED";
    /**
     * Indicates that a process should soon be started by the server.
     */
    ProgressStatusUpdate["TODO"] = "TODO";
    /**
     * Indicates that the server has successfully completed the process.
     */
    ProgressStatusUpdate["DONE"] = "DONE";
    /**
     * Indicates that the server has successfully completed the process and that a resource has validated it.
     */
    ProgressStatusUpdate["VALIDATED"] = "VALIDATED";
})(ProgressStatusUpdate = exports.ProgressStatusUpdate || (exports.ProgressStatusUpdate = {}));
//# sourceMappingURL=progressStatus.js.map